import React, { useEffect, useState } from 'react';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import { createRoot } from 'react-dom/client';
import { Provider, useDispatch } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import AppContainer from './src/app.container';
import setupInterceptors from './src/interceptor';
import configureStore from './src/store';
import { FlagFeaturesProvider } from './src/providers/flagFeature';
import './index.css';
import { getAuthKeys } from './src/modules/login/login.actions';

(() => {
    const isJiraEnabled = process.env.REACT_APP_JIRA_ISSUE_COLLECTOR_ENABLED;

    if (isJiraEnabled === 'true') {
        const src = process.env.REACT_APP_JIRA_ISSUE_COLLECTOR_URL;
        document.write('<script src="' + src + '"><\/script>');
    }
})();

if (!String.prototype.startsWith) {
    String.prototype.startsWith = function (searchString, position) {
        position = position || 0;
        return this.substr(position, searchString.length) === searchString;
    };
}

// Configure Store
const store = configureStore({}, {});

const AppBootstrap = () => {
    const dispatch = useDispatch();
    const [ready, setIsReady] = useState(false);

    useEffect(() => {
        getAuthKeys(dispatch, (response) => {
            if (response) {
                setupInterceptors(store);
                setIsReady(true);
            }
        });
    }, [dispatch]);

    if (!ready) {
        return <></>;
    }

    return (
        <FlagFeaturesProvider>
            <BrowserRouter>
                <AppContainer />
            </BrowserRouter>
        </FlagFeaturesProvider>
    );
};

// Configure Provider
createRoot(document.getElementById('root')).render(
    <Provider store={store}>
        <AppBootstrap />
    </Provider>
);

